const CONTACTS = {
  whatsapp: 'https://wa.me/447557422112',
  whatsappDisplay: '+44 7557 422112',
  telegram: 'https://t.me/+1905307118830',
  telegramDisplay: '+1905307118830',
  email: 'support@beacons-mine.com',
};

export default CONTACTS;
